export const kind = "DocsViewer";
